import {
  Container as RawContainer,
  size,
  Col as RawCol,
  mediaQueries,
  Button as RawButton,
  typography,
  Button,
} from '@everlywell/leaves';
import styled from 'styled-components';

export const Section = styled.div<{ hasControlHero: boolean }>`
  position: relative;
  padding: ${size.md}px 0;

  ${mediaQueries.forTabletHorizontalUp} {
    padding: ${({ hasControlHero }) =>
      hasControlHero ? `${size.xl4}px 0` : `${size.xl1}px 0 ${size.xl4}px 0`};
  }
`;

export const InnerContent = styled.div`
  ${mediaQueries.forTabletHorizontalUp} {
    padding-top: 0;
  }
`;

export const Img = styled.img`
  display: none;
`;

export const DesktopImg = styled.img`
  display: none;
  ${mediaQueries.forTabletHorizontalUp} {
    display: block;
    margin-top: ${size.xl2}px;
    max-width: 72px;
  }
`;

export const CardWrapper = styled.div`
  & > a {
    height: 100%;

    /* TODO: this keeps the images the same height */
    ${mediaQueries.forTabletHorizontalUp} {
      > div:first-of-type {
        min-height: 158px;
        max-height: 158px;
      }
    }
  }
`;

export const Headline = styled.h3`
  text-align: center;
  ${typography.h2Text};
  margin-bottom: ${size.xl2}px;

  ${mediaQueries.forTabletHorizontalUp} {
    margin-bottom: ${size.lg}px;
    text-align: left;
  }
`;

export const MobileHeadline = styled(Headline)`
  margin-top: ${size.md}px;
  text-align: center;

  ${mediaQueries.forTabletHorizontalUp} {
    display: none;
  }
`;

export const DesktopHeadline = styled(Headline)`
  display: none;

  ${mediaQueries.forTabletHorizontalUp} {
    display: block;
  }
`;

export const MobileShopCTAContainer = styled(RawContainer)`
  display: block;
  margin-top: ${size.lg}px;

  ${mediaQueries.forTabletHorizontalUp} {
    display: none;
  }
`;

export const MobileShopCTA = styled(Button)`
  width: 100%;
`;

export const DesktopShopCTAButton = styled(RawButton)`
  display: none;
  ${mediaQueries.forTabletHorizontalUp} {
    display: block;
    width: 176px;
    padding-left: 11px;
    padding-right: 11px;
  }
`;

export const MobileCardsCol = styled(RawCol)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  ${mediaQueries.forPhoneOnly} {
    /* this is in a container and on mobile, design dictates this not be in the grid with 24px padding */
    padding: 0 !important;
  }
`;

export const ContentContainer = styled.div`
  ${mediaQueries.forTabletHorizontalUp} {
    max-width: 192px;
    margin-right: ${size.xl1}px;
    display: flex;
    flex-direction: column;
    height: 100%;
  }
`;

export const DesktopCardsContainer = styled.div`
  flex: auto;
  display: grid;
  grid-template-columns: repeat(2, minmax(157px, 1fr));
  grid-template-rows: repeat(2, 1fr);
  gap: ${size.sm}px ${size.sm}px;
  margin: 0 auto ${size.lg}px auto;

  ${mediaQueries.forTabletVerticalUp} {
    justify-content: center;
    gap: ${size.xl4}px ${size.xl1}px;
    grid-template-columns: repeat(auto-fill, 257px);
    grid-template-rows: repeat(auto-fill, auto);
  }

  ${mediaQueries.forTabletHorizontalUp} {
    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
    grid-template-rows: 1fr 0;
    gap: ${size.md}px ${size.xl1}px;
    padding: 0 ${size.sm}px;
    overflow: hidden;
  }

  ${mediaQueries.forDesktopUp} {
    grid-template-columns: repeat(auto-fill, minmax(223px, 1fr));
  }
`;
